import { Component, inject, Input, OnInit, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router, UrlTree } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  standalone: false,
})
export class PaginationComponent implements OnInit, OnChanges, OnDestroy {
  delta: number = 2;
  currentPage: number = 1;
  showedPages!: number[];
  lengthOfShowedPages: number = 5;
  queryParamsSubscription!: Subscription;

  @Input() itemsPerPage!: number;
  @Input() numberOfPages!: number;

  private readonly router: Router = inject(Router);
  private readonly route: ActivatedRoute = inject(ActivatedRoute);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.numberOfPages?.currentValue) {
      this.initPagination();
    }
  }

  ngOnInit(): void {
    this.initPagination();
  }

  ngOnDestroy(): void {
    this.queryParamsSubscription.unsubscribe();
  }

  initPagination(): void {
    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      if (Object.hasOwn(params, 'page')) {
        this.currentPage = Number.parseInt(params.page, 10);
      } else {
        this.currentPage = 1;
      }

      this.showedPages = this.setShowedPages(this.currentPage, this.numberOfPages, this.lengthOfShowedPages, this.delta);
    });
  }

  setShowedPages(currentPage: number, lastPage: number, showedPages: number, delta: number): number[] {
    const range: number[] = [],
          left: number = currentPage - delta,
          right: number = currentPage + delta + 1;

    if (currentPage < showedPages - left) {
      if (lastPage > showedPages) {
        for (let i: number = 1; i <= showedPages; i++) {
          range.push(i);
        }
      } else {
        for (let i: number = 1; i <= lastPage; i++) {
          range.push(i);
        }
      }
    } else {
      for (let i: number = 1; i <= lastPage; i++) {
        if (i >= left && i < right) {
          range.push(i);
        }
      }
    }

    return range;
  }

  showFirstPageWithDots(): boolean {
    return this.currentPage > this.delta + 1;
  }

  showLastPageWithDots(): boolean {
    return this.numberOfPages > this.lengthOfShowedPages && this.currentPage < this.numberOfPages - this.delta;
  }

  pageUrl(): string {
    return decodeURIComponent(this.router.url.split('?')[0]);
  }

  queryParams(page: number): any {
    const urlTree: UrlTree = this.router.parseUrl(this.router.url);
    urlTree.queryParams.page = page;
    return urlTree.queryParams;
  }

  getPaginationItemWidth(page: number): string {
    return (page.toString().length <= 3 ? 30 : (page.toString().length * 10)) + 'px';
  }
}
